<template>
  <PublicLayout variant="no-bg" :hero="false" breadcrumbs-in-content>
    <UContainer>
      <div class="py-8">
        <h1
          class="text-size-h3 leading-9.5 tracking-[-0.004em] font-semibold text-content-default mb-8"
          style="font-family: Inter"
        >
          Документы
        </h1>
      </div>

      <div class="grid grid-cols-3 gap-5">
        <SmallCard
          v-for="(document, index) in documents"
          :key="index"
          icon="i-local-file-award"
          top="Документ"
          :bottom="document.name"
          no-link
          :to="document.to"
          :ui="{
            bottom: 'text-accent-default! text-size-md',
            iconWrapper: 'w-8 h-8 bg-info text-white',
          }"
        />
      </div>
    </UContainer>
  </PublicLayout>
</template>

<script setup lang="ts">
import PublicLayout from '~/layouts/PublicLayout.vue'

defineOptions({
  name: 'DocumentsPage',
})

definePageMeta({
  breadcrumbs: [{ name: 'Главная', to: '/' }, { name: 'Документы' }],
})

useSeo({
  title: 'Документы',
  description: 'Правовые документы и политики платформы «Код Спорта».',
  canonicalPath: '/documents',
  noindex: true,
})

const documents = [
  { name: 'Политика конфиденциальности', to: '/documents/privacy' },
  {
    name: 'Политика обработки персональных данных',
    to: '/documents/personal-data',
  },
  { name: 'Политика использования cookie', to: '/documents/cookie' },
]
</script>
